//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Divider, Skeleton } from '@backmarket/design-system'

import translations from './Placeholder.translations'

export default {
  components: {
    Divider,
    Skeleton,
  },
  computed: {
    contentPlaceholderSizes() {
      return ['100%', '25%', '75%', '50%', '75%', '25%', '50%']
    },
    translations: () => translations,
  },
}
